const teamsActionTypes = {
  SET_TEAMS_LIST: 'SET_TEAMS_LIST',
  UPDATE_TEAM: 'UPDATE_TEAM',
  DELETE_TEAM: 'DELETE_TEAM',
  CREATE_TEAM: 'CREATE_TEAM',
  SET_AUTHORIZED_TEAMS_LIST: 'SET_AUTHORIZED_TEAMS_LIST',
  SET_TEAMS_HASH: 'SET_TEAMS_HASH',
};
export default teamsActionTypes;
